import { Link, useParams } from 'react-router-dom';

import { ImprovementSignalsPanel } from '../components/ImprovementSignalsPanel';

/** Standalone view for `/document-types/:slug/recommendations`. */
export function RecommendationsPage(): JSX.Element {
  const { slug } = useParams<{ slug: string }>();

  if (slug === undefined) {
    return (
      <div className="card border-rose-200 bg-rose-50 p-4 text-sm text-rose-800">
        Slug no especificado.
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">
            Mejoras sugeridas
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Tipo de documento <span className="font-mono">{slug}</span>
          </p>
        </div>
        <Link
          to={`/document-types/${encodeURIComponent(slug)}`}
          className="btn-secondary"
        >
          ← Volver al tipo
        </Link>
      </header>

      <ImprovementSignalsPanel slug={slug} />
    </div>
  );
}
